import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ImageComponent from '../../../components/common/Image';
import Modal, { ModalBody } from '../../../components/common/Modal';
import { getCurrentStepInfo, getProgressPercentage, STAGE_STEPS } from '../../../config/stageConfig';

function Header() {

  const href = "#";
  const [showStepModal, setShowStepModal] = useState(false);

  const navigate = useNavigate()
  const { stage, subStage, productDetailsData } = useSelector(state => state.eligibility)

  // Get dynamic step information
  const { currentStep, totalSteps } = getCurrentStepInfo(stage, subStage);
  const progressPercentage = getProgressPercentage(stage, subStage);

  const getStageTitle = () => {
    if (stage === "credit_decision") {
      return "Basic Details"
    } else if ((stage === "kyc") && (subStage === "kyc-in-progress")) {
      return "KYC"
    } else if ((stage === "kyc") && (subStage === "fos_selfie")) {
      return "Sourcing Agent Selfie"
    } else if (stage === "product") {
      return "Product Details"
    } else if (stage === "mandate") {
      return "Bank Details"
    } else if (stage === "document") {
      return "Documents"
    } else if (stage === "imei_validation") {
      if (productDetailsData?.response_data?.category?.toLowerCase() === 'mobile phone') {
        return "IMEI Number Validation"
      }
      else {
        return "Serial Number Validation"
      }
    } else if (stage === "invoice_details") {
      return "Invoice Details"
    }
    return "KYC" // Default fallback  
  }

  const getStageSubtitle = () => {
    if ((stage === "kyc") && (subStage === "kyc-in-progress")) {
      return "Complete Identity Verification"
    } else if ((stage === "kyc") && (subStage === "fos_selfie")) {
      return ""
    }
    return ""
  }

  const handleStepModalToggle = () => {
    setShowStepModal(!showStepModal);
  }

  const handleCloseStepModal = () => {
    setShowStepModal(false);
  }

  // Helper function to get step status
  const getStepStatus = (stepNumber) => {
    if (stepNumber < currentStep) return 'complete';
    if (stepNumber === currentStep) return 'active';
    return 'pending';
  }

  const getStepStatusText = (stepNumber) => {
    if (stepNumber < currentStep) return 'Completed';
    if (stepNumber === currentStep) return 'In-progress';
    return 'Pending';
  }

  return (
    <>
      <header className={(stage === "kyc") && (subStage === "fos_selfie") ? "sticky-top" : "fixed-top"}>
        <div className="container-fluid topNav product-topNav">
          <div className="row web-header">
            <div
              className="d-flex flex-wrap align-items-center justify-content-between"
            >
              <div className="d-flex align-items-center tablet-content">
                <a href="Dashboard.html">
                  <ImageComponent fileName="cholacd.svg" alt="cholacd" style={{ height: "40px" }} className="img-fluid tab-logo" />
                </a>
              </div>
            </div>
          </div>
          <div className={`mob-header ${(stage === "kyc") && (subStage === "fos_selfie") ? 'mt-2' : ''}`}>
            <div className="">
              <div className="text-white d-flex align-items-center justify-content-between">

                <div className="d-flex align-items-center gap-2">
                  <div className="icon-arrowleftl1 "
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/dashboard');
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate('/dashboard');
                      }
                    }}
                    tabIndex={0}
                    role="button"
                    aria-label="Go back to dashboard"
                  ></div>
                  <div>
                    <div className="fs-6 fw-medium">{getStageTitle()}</div>
                    <div className="small d-none">{getStageSubtitle()}</div>
                  </div>
                </div>
                {!((stage === "kyc") && (subStage === "fos_selfie")) && (
                  <div>
                    <div
                      className={`pie-wrapper progress-${progressPercentage} style-2`}
                      onClick={handleStepModalToggle}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          handleStepModalToggle();
                        }
                      }}
                      tabIndex={0}
                      role="button"
                      aria-label="View application steps"
                    >
                      <span className="label">{currentStep}/{totalSteps}</span>
                      <div className="pie">
                        <div className="left-side half-circle"></div>
                        <div className="right-side half-circle"></div>
                      </div>
                      <div className="shadow"></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </header >

      <Modal
        id="stepRole"
        show={showStepModal}
        onClose={handleCloseStepModal}
        labelledBy="SelectRole"
        modalClass="modal-dialog modal-dialog-centered"
      >
        <ModalBody>
          <div className="stepper-title">
            <div className="d-flex align-items-center justify-content-between stepper-title-text">
              <p className="mb-0">Complete Steps</p>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseStepModal}
                aria-label="Close"
              ></button>
            </div>
            <p className="mb-0 stepper-title-content">You are few steps away from obtaining your<br />Consumer Durable loan</p>
          </div>
          <div className="container p-0">
            <div className="steps-vertical">
              {STAGE_STEPS.map((stageStep, index) => {
                const stepStatus = getStepStatus(stageStep.step);
                const statusText = getStepStatusText(stageStep.step);

                return (
                  <div key={stageStep.key} className={`step-vertical ${stepStatus}`}>
                    <div className="step-vertical-icon">
                      {stepStatus === 'complete' && <i className="icon-Essetional-Tick-1"></i>}
                    </div>
                    <div className="step-vertical-content">
                      <p className="stp">Step {stageStep.step}</p>
                      <h6 className="name">{stageStep.name}</h6>
                      <p className="status">{statusText}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default Header